import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export const getRahuTransits = async (body: any, language: string) => {
  try {
    const url = `${urls.rahuTranist}/${language}`;
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
